import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { getEntities as getVehiclePositions } from 'app/entities/vehicle-position/vehicle-position.reducer';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { createEntity, getEntity, reset, updateEntity } from './identification-code-alert.reducer';

export const IdentificationCodeAlertUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const vehiclePositions = useAppSelector(state => state.vehiclePosition.entities);
  const identificationCodeAlertEntity = useAppSelector(state => state.identificationCodeAlert.entity);
  const loading = useAppSelector(state => state.identificationCodeAlert.loading);
  const updating = useAppSelector(state => state.identificationCodeAlert.updating);
  const updateSuccess = useAppSelector(state => state.identificationCodeAlert.updateSuccess);

  const handleClose = () => {
    props.history.push('/identification-code-alert' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getVehiclePositions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...identificationCodeAlertEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      vehiclePosition: vehiclePositions.find(it => it.id.toString() === values.vehiclePositionId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...identificationCodeAlertEntity,
          created: convertDateTimeFromServer(identificationCodeAlertEntity.created),
          truckImplementId: identificationCodeAlertEntity?.truckImplement?.id,
          companyId: identificationCodeAlertEntity?.company?.id,
          vehiclePositionId: identificationCodeAlertEntity?.vehiclePosition?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.identificationCodeAlert.home.createOrEditLabel" data-cy="IdentificationCodeAlertCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.identificationCodeAlert.home.createOrEditLabel">Create or edit a IdentificationCodeAlert</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="identification-code-alert-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.identificationCodeAlert.value')}
                id="identification-code-alert-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.identificationCodeAlert.created')}
                id="identification-code-alert-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="identification-code-alert-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.identificationCodeAlert.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="identification-code-alert-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.identificationCodeAlert.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="identification-code-alert-vehiclePosition"
                name="vehiclePositionId"
                data-cy="vehiclePosition"
                label={translate('fleetSenseApp.identificationCodeAlert.vehiclePosition')}
                type="select"
              >
                <option value="" key="0" />
                {vehiclePositions
                  ? vehiclePositions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/identification-code-alert" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default IdentificationCodeAlertUpdate;
